import React from 'react';
import { Link } from 'react-router-dom';
import CardUI from '../../../widgets/layout/CardUI.js';
import IconButtonUI from '../../../widgets/action/IconButtonUI.js';
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js';
import GenericErrorUI from '../../../components/common/GenericErrorUI.js';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js';
import CommercialCibilDownloadModalSF from '../../../components/superUser/account/CommercialCibilDownloadModalSF.js';
import ConsumerCibilDownloadModalSF from '../../../components/superUser/account/ConsumerCibilDownloadModalSF.js';
import './RiskRegister.css';

const DaysPastDuePageUI = ({ context, errorList, daysPastDueList,
  downloadMode, downloadConsumerMode, onDownloadClick, onDownloadConsumerClick, onDownloadCancel, onDownloadConsumerCancel,
  response, showDownloadClick, onShowDownloadClick, onRefreshClick
}) => (
  <SuperUserHomePageUI context={context} className='pg_su_dpd' topnav='accounts'
    centered={!errorList && !daysPastDueList} page='daysPastDue'
  >
    {
      !errorList && !daysPastDueList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      daysPastDueList && (
        <div>
          <LRTableActionsUI
            location='top'
            left={
              <div className='g_flex_h'>
                <IconButtonUI icon='icon-refresh' label='Refresh' onClick={onRefreshClick} />

                <IconButtonUI to="#" icon='icon-download' label='Commercial Cibil' onClick={onDownloadClick} />

                <IconButtonUI icon='icon-download' label='Consumer Cibil' onClick={onDownloadConsumerClick} />

                <span className='g_m_left_100 g_large'><b>Days Past Due, {response.yearMonth.monthName} {response.yearMonth.year}</b></span>
              </div>
            }
            right={
              <span>
                <Link to={`/su/dpd/${response.yearMonth.prevYear}/${response.yearMonth.prevMonth}`}>Previous</Link>
                <span className='g_m_left_100' />
                <Link to={`/su/dpd/${response.yearMonth.nextYear}/${response.yearMonth.nextMonth}`}>Next</Link>
              </span>
            }
          />

          <CommercialCibilDownloadModalSF
            context={context}
            downloadMode={downloadMode}
            onCancelClick={onDownloadCancel}
          />

          <ConsumerCibilDownloadModalSF
            context={context}
            downloadMode={downloadConsumerMode}
            onCancelClick={onDownloadConsumerCancel}
          />

          <div>
            <CardUI className='g_m_bottom_100' title={daysPastDueList.daysPastDue}>
              <table>
                <thead className='g_sticky'>
                  <tr className='head'>
                    <th className='g_p_left_100'>S no.</th>
                    <th className='g_p_left_100'>Account Name</th>
                    <th className='g_p_left_100'>Loan Name</th>
                    <th className='g_p_left_100'>LRN</th>
                    <th className='g_p_left_100'>Days Past Due</th>
                    <th className='g_p_left_100'>Outstanding Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {daysPastDueList.map((dpd, index) => (
                    <tr className='body' key={index}>
                      <td className='g_text_right amt'>{index + 1}.</td>
                      <td className='left g_no_wrap_2'>{dpd.accountName}</td>
                      <td className='left g_no_wrap_2'>{dpd.loanName}</td>
                      <td className='g_text_right amt'>{dpd.loanReferenceNumber}</td>
                      <td className='g_text_right amt'>{dpd.daysPastDue}</td>
                      <td className='g_text_right amt'>{dpd.outstandingBalance}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardUI>
          </div>
        </div>
      )}

  </SuperUserHomePageUI>
)

export default DaysPastDuePageUI;
